// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionLoader_container__l_pyh","loader":"SectionLoader_loader__hxoih","spinning-loader":"SectionLoader_spinning-loader__opj2x"};